<template>
    <div class="progress_bar"></div>
</template>

<script>

export default {
    name: "progress_bar",
}
</script>
